import { FormattedMessage } from 'react-intl';
import ErrorLayout from './ErrorLayout';

const RequestTimeout = () => (
  <ErrorLayout
    title={
      <FormattedMessage
        id="error.timeout.title"
        defaultMessage="No connection to the server"
      />
    }
  >
    <>
      <p className="description">
        <FormattedMessage
          id="error.timeout.body"
          defaultMessage="The backend is not responding due to a server timeout or a connection problem of your device. Please check your connection and try again."
        />
      </p>
      <p>
        <FormattedMessage id="error.thanks" defaultMessage="Thank you." />
      </p>
    </>
  </ErrorLayout>
);

export default RequestTimeout;
